@if (control) {
  <mat-form-field>
    @if (label()) {
      <label
        [for]="inputId"
        [ngClass]="{ 'text-red': control.invalid && (control.dirty || control.touched) }"
      >
        <span
          >{{ label() }}
          @if (isRequired && !hideRequiredMarker()) {
            <span class="required">*</span>
          }
        </span>
      </label>
    }

    @if (multiline()) {
      <textarea
        matInput
        [id]="inputId"
        [formControl]="control"
        [rows]="rows()"
        [readonly]="readonly()"
        [placeholder]="placeholder()"
        [attr.maxlength]="maxlength()"
        [attr.aria-label]="ariaLabel() || null"
        [ngClass]="'text-' + alignment()"
        (blur)="blur.emit()"
      ></textarea>
    } @else {
      <input
        matInput
        [id]="inputId"
        [type]="inputType"
        [autocomplete]="autocompleteComputed()"
        [formControl]="control"
        [mask]="maskComputed()"
        [thousandSeparator]="type() === 'money' ? ',' : ''"
        [prefix]="prefixComputed()"
        [dropSpecialCharacters]="dropSpecialCharacters()"
        [pattern]="patternComputed()"
        [step]="stepComputed()"
        [min]="minComputed()"
        [max]="max()"
        [readonly]="readonly()"
        [placeholder]="placeholder()"
        [attr.maxlength]="maxlength()"
        [attr.aria-label]="ariaLabel() || null"
        [ngClass]="'text-' + alignment()"
        (blur)="blur.emit()"
      />
    }

    @if (startHint()) {
      <mat-hint align="start">{{ startHint() }}</mat-hint>
    }
    @if (endHint()) {
      <mat-hint align="end">{{ endHint() }}</mat-hint>
    }
    @if (showError) {
      <mat-error>{{ getErrorMessage(errorKeys[0]) }}</mat-error>
    }
  </mat-form-field>
}
